// components/admin/industries/IndustryTable.jsx
import React from 'react';
import { Switch } from "../ui/switch";
import { Button } from "../ui/button";
import { PencilIcon } from "lucide-react";
import toast from "react-hot-toast";
const API = process.env.REACT_APP_API_BASE;

export default function IndustryTable({ industries, setIndustries, onEdit }) {
    const handleStatusToggle = (id, newStatus) => {
      fetch(`${API}/api/industries/${id}/isActive`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ isActive: newStatus })
      })
        .then(res => res.json())
        .then(updated => {
          setIndustries(updated);
          toast.success('Status updated');
        })
        .catch(() => toast.error('Failed to update status'));
    };
  
  
    return (
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="bg-muted text-left">
              <th className="p-3">Name</th>
              <th className="p-3">Display Name</th>
              <th className="p-3">Description</th>
              <th className="p-3">Icon</th>
              <th className="p-3">Status</th>
              <th className="p-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            {industries.map(industry => (
              <tr key={industry._id} className="border-t">
                <td className="p-3">{industry.name}</td>
                <td className="p-3">{industry.displayName}</td>
                <td className="p-3">{industry.description}</td>
                <td className="p-3">{industry.icon}</td>
                <td className="p-3">
                  <Switch
                    checked={industry.status}
                    onCheckedChange={(val) => handleStatusToggle(industry._id, val)}
                  />
                </td>
                <td className="p-3">
                  <Button size="sm" variant="outline" onClick={() => onEdit(industry)}>
                    <PencilIcon className="w-4 h-4" />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }